module.exports = __webpack_public_path__ + "img/si.9e26260e.svg";